import { PrivateInterceptor } from '../../Base/interceptors/PrivateInterceptor'

export const getYarn = async () =>{
    const result = await PrivateInterceptor(`Desarrollo/getYarn`, 'GET');
    return result;
}

export const getCalibres = async () =>{
    const result = await PrivateInterceptor(`Desarrollo/getCalibres`, 'GET');
    return result;
}

export const getTypes = async () =>{
    const result = await PrivateInterceptor(`Desarrollo/getTypes`, 'GET');
    return result;
}

export const getEfectos = async () =>{
    const result = await PrivateInterceptor(`Desarrollo/getEfectos`, 'GET');
    return result;
}

export const getFibras = async () =>{
    const result = await PrivateInterceptor(`Desarrollo/getFibras`, 'GET');
    return result;
}

export const getTypesCotton = async () =>{
    const result = await PrivateInterceptor(`Desarrollo/getTypesCotton`, 'GET');
    return result;
}

export const getRecycled = async () =>{
    const result = await PrivateInterceptor(`Desarrollo/getRecycled`, 'GET');
    return result;
}

// -----------------------------------------AGREGAR Y EDITAR ----------------------------------------

export const GuardarCalibre = (DatosCalibre) => {
    const respuesta = PrivateInterceptor("Desarrollo/GuardarCalibre", "POST", {DatosCalibre});
    return respuesta;
};

export const EditarCalibre = (DatosCalibre) => {
    const respuesta = PrivateInterceptor("Desarrollo/EditarCalibre", "POST", {DatosCalibre});
    return respuesta;
};

export const GuardarType = (DatosType) => {
    const respuesta = PrivateInterceptor("Desarrollo/GuardarType", "POST", {DatosType});
    return respuesta;
};

export const EditarType = (DatosType) => {
    const respuesta = PrivateInterceptor("Desarrollo/EditarType", "POST", {DatosType});
    return respuesta;
};

export const GuardarEfecto = (DatosEfecto) => {
    const respuesta = PrivateInterceptor("Desarrollo/GuardarEfecto", "POST", {DatosEfecto});
    return respuesta;
};

export const EditarEfecto = (DatosEfecto) => {
    const respuesta = PrivateInterceptor("Desarrollo/EditarEfecto", "POST", {DatosEfecto});
    return respuesta;
};

export const GuardarFibra = (DatosFibra) => {
    const respuesta = PrivateInterceptor("Desarrollo/GuardarFibra", "POST", {DatosFibra});
    return respuesta;
};

export const EditarFibra = (DatosFibra) => {
    const respuesta = PrivateInterceptor("Desarrollo/EditarFibra", "POST", {DatosFibra});
    return respuesta;
};

export const GuardarTypesC = (DatosTypesC) => {
    const respuesta = PrivateInterceptor("Desarrollo/GuardarTypesC", "POST", {DatosTypesC});
    return respuesta;
};

export const EditarTypesC = (DatosTypesC) => {
    const respuesta = PrivateInterceptor("Desarrollo/EditarTypesC", "POST", {DatosTypesC});
    return respuesta;
};

export const GuardarRecycled = (DatosRecycled) => {
    const respuesta = PrivateInterceptor("Desarrollo/GuardarRecycled", "POST", {DatosRecycled});
    return respuesta;
};

export const EditarRecycled = (DatosRecycled) => {
    const respuesta = PrivateInterceptor("Desarrollo/EditarRecycled", "POST", {DatosRecycled});
    return respuesta;
};

// -----------------------------------------YARN ----------------------------------------------
export const ObtenerSiguienteCorrelativoC = () => {
    const respuesta = PrivateInterceptor("Desarrollo/ObtenerSiguienteCorrelativoC", "GET");
    return respuesta;
};

export const getYarnDetailsPorID = (IdYarnTitle) => {
    const respuesta = PrivateInterceptor("Desarrollo/getYarnDetailsPorID", "POST", {IdYarnTitle});
    return respuesta;
};

export const GuardarYarnCotton = (DatosEncabezado, DatosDetalle) => {
    const respuesta = PrivateInterceptor("Desarrollo/GuardarYarnCotton", "POST", {DatosEncabezado, DatosDetalle});
    return respuesta;
};

export const EditarYarnCotton = (DatosEncabezado, DatosDetalle) => {
    const respuesta = PrivateInterceptor("Desarrollo/EditarYarnCotton", "POST", {DatosEncabezado, DatosDetalle});
    return respuesta;
};

export const EliminarYarn = (DatosEncabezado) => {
    const respuesta = PrivateInterceptor("Desarrollo/EliminarYarn", "POST",{DatosEncabezado});
    return respuesta;
};

export const EliminarYarnDetail = (DatosDetalle) => {
    const respuesta = PrivateInterceptor("Desarrollo/EliminarYarnDetail", "POST",{DatosDetalle});
    return respuesta;
};

export const EliminarYarnDetail2 = (DatosDetalle) => {
    const respuesta = PrivateInterceptor("Desarrollo/EliminarYarnDetail2", "POST",{DatosDetalle});
    return respuesta;
};